import { Injectable } from '@angular/core';
import {
  DynamicOrchestrator,
  OrchestratorForm,
  OrchestratorComponents,
} from '@games/shared/orchestrator';

@Injectable()
export class MathResultContainerOrchestrator extends DynamicOrchestrator {
  preForm = () => {
    return <OrchestratorForm>{
      padding: {
        for: 'outerBox',
        width: 12,
        height: 20,
        top: 1.5,
        right: 0.5,
        left: 0.5,
        bottom: 1.5,
      },
      column: [
        {
          for: 'correctAnswerWrapper',
          take: 3,
          column: [
            {
              for: 'correctAnswer',
              fontSize: {
                height: 0.2,
                width: 0.3,
              },
            },
          ],
        },
        {
          for: 'resultWrapper',
          take: 5,
          column: [
            {
              for: 'result',
              component: OrchestratorComponents.fitText(),
            },
          ],
        },
        {
          for: 'buttonContainer',
          take: 3,
          column: [
            {
              for: 'button',
              component: OrchestratorComponents.gameButton(),
              stretchWidth: 0.8,
              stretchHeight: 0.8,
              heightToWidth: 0.9,
              maxHeight: 140,
            },
          ],
        },
      ],
    };
  };

  provideResults() {
    this.form();
  }
}
